import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 5px;
  justify-content: space-between;

  p {
    width: calc(100% - 5px);
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 5px;
    color: #000;
  }
`;

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  body {
    background: #f0f2f5;
    color: #000;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #000;
  }

  button {
    cursor: pointer;
  }
`;